// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
//import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

window.global = window;
global.$ = require("jquery");
window.$ = global.$;

require("jquery")
require("jquery-ui")
//require('jquery-ui-dist/jquery-ui');
//require("jquery-ujs")
//require("jquery-ui/ui/widgets/draggable.js")

//require("guillotine/js/jquery.guillotine.js")

//import '../js/services/uploader/vendor/jquery.ui.widget.js' 
//import '../js/services/uploader/jquery.fileupload.js' 

//import '../js/services/modernizr.2.5.3.min.js'
import '../js/services/flipbook.js' 
//import '../js/services/scrollto.js' 
//import 'modernizr' 

Rails.start()
//Turbolinks.start()
ActiveStorage.start()


window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

//import 'fabric' 
//import 'wookmark';
//require("js/controllers/fabric_extention.js");

import '../js/angular/angular.js'
import '../js/angular/angular-resource.js'
import '../js/angular/angular-sanitize.js'

import "@fortawesome/fontawesome-free/js/all"

//import 'bootstrap-colorpicker'

// Define the `phonecatApp` module
window.B2cApp = angular.module('B2cApp', []);



require("js/controllers/LiseusesCtrl.js");
require("js/controllers/UploaderCtrl.js");
require("js/controllers/PaymentCtrl.js");




$( document ).ready(function() {
  $(window).on('resize', function() {
    location.reload();
  })
  //$('[data-toggle="tooltip"]').tooltip()
  
  //var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  //var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  //  return new bootstrap.Tooltip(tooltipTriggerEl)
  //})
//    //alert($("#test").html())
//  
//  //for (var i = 0; i < $('.preview_page').length; i++) {
//  //  
//  //  var canvas = new fabric.Canvas($($('.preview_page')[i]));
//  //
//  //  var rect = new fabric.Rect({
//  //      top : 100,
//  //      left : 100,
//  //      width : 60,
//  //      height : 70,
//  //      fill : 'red'
//  //  });
//  //
//  //  canvas.add(rect);
//  //  
//  //}
});



